import { downloadBlob } from "@/services/invoicePdf";

const MODAL_ID = "pdf-preview-modal";

/**
 * Shows a PDF in a full-screen preview with Print, Download and Close.
 * The PDF comes from the server as a Blob; no HTML is built in the browser.
 */
export function openPdfPreview(blob, { title = "Invoice", fileName = "invoice.pdf" } = {}) {
  document.getElementById(MODAL_ID)?.remove();
  const url = URL.createObjectURL(blob);

  const modal = document.createElement("div");
  modal.id = MODAL_ID;
  modal.innerHTML = `
    <div class="pdfp-backdrop" data-close="1"></div>
    <div class="pdfp-dialog" role="dialog" aria-modal="true">
      <div class="pdfp-toolbar">
        <strong class="pdfp-title"></strong>
        <div class="pdfp-actions">
          <button type="button" class="pdfp-btn pdfp-download">Download</button>
          <button type="button" class="pdfp-btn pdfp-print">Print</button>
          <button type="button" class="pdfp-btn pdfp-close" aria-label="Close">Close</button>
        </div>
      </div>
      <iframe class="pdfp-frame" title="Invoice preview"></iframe>
    </div>
    <style>
      #${MODAL_ID}, #${MODAL_ID} * { box-sizing: border-box; }
      #${MODAL_ID} { position: fixed; inset: 0; z-index: 100000; font-family: Arial, sans-serif; }
      #${MODAL_ID} .pdfp-backdrop { position: absolute; inset: 0; background: rgba(17, 24, 39, .72); }
      #${MODAL_ID} .pdfp-dialog { position: absolute; inset: 24px; display: flex; flex-direction: column; background: #fff; border-radius: 10px; overflow: hidden; box-shadow: 0 20px 50px rgba(0,0,0,.3); }
      #${MODAL_ID} .pdfp-toolbar { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 10px 14px; border-bottom: 1px solid #e5e7eb; flex-wrap: wrap; }
      #${MODAL_ID} .pdfp-actions { display: flex; gap: 8px; }
      #${MODAL_ID} .pdfp-btn { border: 1px solid #d1d5db; background: #fff; border-radius: 6px; padding: 7px 14px; cursor: pointer; font-size: 14px; }
      #${MODAL_ID} .pdfp-print { background: #111827; border-color: #111827; color: #fff; }
      #${MODAL_ID} .pdfp-frame { flex: 1; width: 100%; border: 0; background: #525659; }
      @media (max-width: 600px) { #${MODAL_ID} .pdfp-dialog { inset: 6px; } }
    </style>`;
  modal.querySelector(".pdfp-title").textContent = title;
  document.body.appendChild(modal);

  const previousOverflow = document.body.style.overflow;
  document.body.style.overflow = "hidden";
  const iframe = modal.querySelector(".pdfp-frame");
  iframe.src = url;

  const close = () => {
    document.removeEventListener("keydown", onKeydown);
    document.body.style.overflow = previousOverflow;
    modal.remove();
    URL.revokeObjectURL(url);
  };
  const onKeydown = (event) => {
    if (event.key === "Escape") close();
  };

  modal.querySelector(".pdfp-print").addEventListener("click", () => {
    try {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    } catch {
      // Some browsers do not allow printing an embedded PDF; the viewer opens in a tab instead.
      window.open(url, "_blank", "noopener");
    }
  });
  modal.querySelector(".pdfp-download").addEventListener("click", () => downloadBlob(blob, fileName));
  modal.querySelector(".pdfp-close").addEventListener("click", close);
  modal.querySelector(".pdfp-backdrop").addEventListener("click", close);
  document.addEventListener("keydown", onKeydown);
  return { close };
}
